var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseLogoBar'),_c('BaseNavbar'),_c('div',{staticClass:"d-flex",attrs:{"id":"wrapper"}},[_c('div',{staticClass:"mb-4",attrs:{"id":"page-content-wrapper"}},[_c('div',{staticClass:"mb-4"},[_c('router-view')],1)])]),_c('BaseFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }